/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { productOptions } from '../../productOptions';

/**
 * Addon selection
 *
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Minifigs
 */

const frontTextFieldNames = [
    'input[name="properties[Text]"]',
    'input[name="properties[What text would you like?]"]',
    'input[name="properties[Would you like text on the front?]"]',
    'input[name="properties[Text for the front]"]',
    'textarea[name="properties[Text]"]',
    'textarea[name="properties[What text would you like?]"]',
];
const backTextFieldNames = [
    'input[name="properties[Text for the back]"]',
    'input[name="properties[What back text would you like?]"]',
    'textarea[name="properties[Text for the back]"]',
    'textarea[name="properties[What back text would you like?]"]',
];

const Addons = ({
    addons,
    productId,
    torsoText: torsoTextRedux,
    frontTextEventListenerExists,
    backTextEventListenerExists,
    setBackTextEventListenerExists,
    setFrontTextEventListenerExists,
    setTorsoBackText,
    setTorsoFrontText,
}) => {
    const addonRef = useRef(null);
    const addonsContainer = useRef(null);

    useEffect(() => {
        if (!addonsContainer.current) return;

        const stripEmojis = (str) =>
            str
                .replace(
                    /(?![*#0-9]+)[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]/gu,
                    ''
                )
                .replace(/\s+/g, ' ');

        const handleNodeUpdate = () => {
            backTextFieldNames.forEach((backTextFieldName) => {
                const backTextField = addonsContainer.current.querySelector(backTextFieldName);
                if (backTextField && !backTextEventListenerExists) {
                    setBackTextEventListenerExists(true);

                    backTextField.addEventListener('input', () => {
                        setTorsoBackText(backTextField.value);
                    });
                }
            });

            frontTextFieldNames.forEach((frontTextFieldName) => {
                const frontTextField = addonsContainer.current.querySelector(frontTextFieldName);
                if (frontTextField && !frontTextEventListenerExists) {
                    setFrontTextEventListenerExists(true);

                    frontTextField.addEventListener('input', () => {
                        setTorsoFrontText(frontTextField.value);
                    });
                }
            });

            const inputs = addonsContainer.current.querySelectorAll('textarea, input[type="text"] ');
            inputs.forEach((input) =>
                input.addEventListener('input', () => {
                    const strippedValue = stripEmojis(input.value);
                    input.value = strippedValue;
                })
            );
        };

        const observer = new MutationObserver((mutationList) =>
            mutationList
                .filter((m) => m.type === 'childList')
                .forEach((m) => {
                    m.addedNodes.forEach(
                        (element) => element.querySelector('textarea, input[type="text"]') && handleNodeUpdate()
                    );
                })
        );
        observer.observe(addonsContainer.current, { childList: true, subtree: true });
    }, [
        frontTextEventListenerExists,
        backTextEventListenerExists,
        torsoTextRedux,
        setBackTextEventListenerExists,
        setFrontTextEventListenerExists,
        setTorsoFrontText,
        setTorsoBackText,
    ]);

    const addonsArr = addons?.option_product?.option_sets;
    let addonsRet = false;

    if (typeof addonsArr === 'undefined' || !addonsArr) {
        window.addonArr = false;
    } else {
        window.addonArr = addonsArr;
        productOptions();
        addonsRet = <div ref={addonRef} className="bold_options" data-product-id={`${productId}`} />;
    }

    return (
        <div className="product-addons" ref={addonsContainer}>
            {addonsArr && addonsRet && (
                <>
                    <h3>Customise your product</h3>
                    {addonsRet}
                </>
            )}
        </div>
    );
};

Addons.propTypes = {
    addons: PropTypes.object,
    productId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    return {
        torsoText: state.builds[state.currentBuildIndex].torsoText,
    };
};

export default connect(mapStateToProps)(Addons);
